import { useNavigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Globe } from 'lucide-react';
import Boutton from "./Button.jsx";
import axios from "./AxiosInstance.jsx";

const Header = ({ gameState, refreshGameState }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const [loading, setLoading] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);

    const stat = () => {
        navigate("/stats/countries");
    };

    const login = () => {
        navigate("/login");
    };

    const newGame = async () => {
        try {
            setLoading(true);
            const response = await axios.get("/new_game");
            await navigate("/accueil");
            if (response.status != 200) {
                throw new Error("Erreur lors de la création de la nouvelle partie");
            }

            await new Promise(resolve => setTimeout(resolve, 1000));
            await refreshGameState();

        } catch (error) {
            console.error("Erreur lors de la requête new_game :", error);
            alert("Impossible de lancer la partie. Veuillez réessayer.");
        } finally {
            setLoading(false);
        }
    };


    return (
        <>
            <header className="header flex items-center justify-between px-4 py-2">
                <div className="flex items-center space-x-4 relative">
                    <button onClick={() => navigate("/")}>
                        <img
                            src="/logoGeo.svg"
                            alt="GeoPolitikIA logo."
                            width={300}
                            height={64}
                        />
                    </button>
                </div>
                <div className="flex items-center space-x-2">
                    {(gameState?.state === "game" && location.pathname != "/game") && (
                        <Boutton
                            text="BACK_GAME"
                            onClick={() => navigate("/game")}
                            text_after="COME_BACK"
                            delay={0}
                            variant="green"
                        />
                    )}
                    {(location.pathname == "/over" || location.pathname == "/win") && (
                        <Boutton
                            text="STATS"
                            onClick={stat}
                            text_after="📈📊"
                            delay={0}
                            variant="yellow"
                        />
                    )}
                    <Boutton
                        text="END_GAME"
                        onClick={() => setShowConfirm(true)}
                        text_after="NEW_GAME"
                        delay={0}
                        variant="red"
                    />
                    <Boutton
                        text="⚙️CONFIG "
                        onClick={login}
                        text_after="⚙️LOGIN"
                        delay={0}
                        variant="grey"
                    />
                </div>
            </header >
            {showConfirm && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
                    <div className="bg-white rounded-xl p-6 shadow-xl max-w-md w-full text-center">
                        <h2 className="text-xl font-bold text-red-600 mb-4">Confirmation</h2>
                        <p className="text-sm text-gray-700 mb-6">
                            Cette action est irréversible et supprimera la partie en cours. Voulez-vous vraiment commencer une nouvelle partie ?
                        </p>
                        <div className="flex justify-center space-x-4">
                            <button
                                onClick={() => setShowConfirm(false)}
                                className="px-4 py-2 rounded bg-gray-500 hover:bg-gray-300"
                            >
                                Annuler
                            </button>
                            <button
                                onClick={newGame}
                                disabled={loading}
                                className="px-4 py-2 rounded bg-red-600 text-white hover:bg-red-700"
                            >
                                {loading ? "Chargement..." : "Confirmer"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Header;
